class SexuallyTransmittedBloodBorneInfectionScreening {
    public IsGonorrhea: boolean;
    public IsChlamydia: boolean;

    constructor(fields?: Partial<SexuallyTransmittedBloodBorneInfectionScreening>) {
        Object.assign(this, fields);
    }
}

export { SexuallyTransmittedBloodBorneInfectionScreening };
